/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SupportRewardLedgerEntry } from './SupportRewardLedgerEntry';
import {
    SupportRewardLedgerEntryFromJSON,
    SupportRewardLedgerEntryFromJSONTyped,
    SupportRewardLedgerEntryToJSON,
    SupportRewardLedgerEntryToJSONTyped,
} from './SupportRewardLedgerEntry';

/**
 * 
 * @export
 * @interface SupportRewardLedgerMutationResponse
 */
export interface SupportRewardLedgerMutationResponse {
    /**
     * 
     * @type {SupportRewardLedgerEntry}
     * @memberof SupportRewardLedgerMutationResponse
     */
    entry: SupportRewardLedgerEntry;
}

/**
 * Check if a given object implements the SupportRewardLedgerMutationResponse interface.
 */
export function instanceOfSupportRewardLedgerMutationResponse(value: object): value is SupportRewardLedgerMutationResponse {
    if (!('entry' in value) || value['entry'] === undefined) return false;
    return true;
}

export function SupportRewardLedgerMutationResponseFromJSON(json: any): SupportRewardLedgerMutationResponse {
    return SupportRewardLedgerMutationResponseFromJSONTyped(json, false);
}

export function SupportRewardLedgerMutationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportRewardLedgerMutationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'entry': SupportRewardLedgerEntryFromJSON(json['entry']),
    };
}

export function SupportRewardLedgerMutationResponseToJSON(json: any): SupportRewardLedgerMutationResponse {
    return SupportRewardLedgerMutationResponseToJSONTyped(json, false);
}

export function SupportRewardLedgerMutationResponseToJSONTyped(value?: SupportRewardLedgerMutationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entry': SupportRewardLedgerEntryToJSON(value['entry']),
    };
}

